import React from 'react';
import ErrorOutlineOutlinedIcon from '@material-ui/icons/ErrorOutlineOutlined';

import { useSOAlertDetailLang } from './hooks';

import makeClasses from './SOAlertDetail.style';

export function SOAlertDetail() {
  const classes = makeClasses();
  const lang = useSOAlertDetailLang();

  return (
    <div className={classes.root} role='alert'>
      <ErrorOutlineOutlinedIcon className={classes.icon} />
      <p className={classes.text}>{lang.alertText}</p>
    </div>
  );
}
